import { createRouter, createWebHistory } from 'vue-router'
import Home from "@/views/Home.vue";
import WriterCenter from "@/views/WriterCenter.vue";
import NovelChapterList from "@/components/Reader/NovelChapterList.vue";
import NovelReader from "@/components/Reader/NovelReader.vue";
import NovelEditor from "@/components/ChapterEditor/NovelEditor.vue";
import NovelSelector from "@/components/ChapterEditor/NovelSelector.vue";
import NovelDetail from "@/components/ChapterEditor/NovelDetail.vue";
import Test from "@/views/test.vue"
import DraftEditor from "@/components/ChapterEditor/DraftEditor.vue";
import NovelManage from "@/components/BookEditor/NovelManage.vue";
import PersonalMessage from "@/components/Personal/PersonalMessage.vue";
import NewNovelCreate from "@/components/BookEditor/NewNovelCreate.vue";
import YinSi from '@/components/Promise/YinSi.vue';
import ShiYong from '@/components/Promise/ShiYong.vue';
import Cookie from '@/components/Promise/Cookie.vue';
import TestPage from '@/components/Decription/TestPage.vue';
import HomeTest from '@/views/HomeTest.vue';
import Encourage from '@/views/Encourage.vue';
import WordOut from '@/components/Decription/WordOut.vue';
import axios from 'axios';

const routes = [
  {
    path: '/test',
    name: 'Test',
    component: WordOut
  },
  {
    path: '/',
    name: 'homepage',
    component: HomeTest
  },
  {
    path: '/writer',
    name: 'write_center',
    component: WriterCenter,
    meta: { requiresAuth: true } // 标记需要认证的路由
  },
  {
    path: '/novelchapterlist/:id',
    name: 'NovelChapterList',
    component: NovelChapterList
  },
  {
    path: '/novelreader',
    name: 'NovelReader',
    component: NovelReader
  },
  //   编写小说
  {
    path: '/noveleditor:id',
    name: 'NovelEditor',
    component: NovelEditor
  },
  //   编写小说
  {
    path: '/drafteditor:id',
    name: 'DraftEditor',
    component: DraftEditor
  },
  {
    path: '/novelselector',
    name: 'novel_selector',
    component: NovelSelector
  },
  {
    path: '/noveldetail:id',
    name: 'NovelDetail',
    component: NovelDetail
  },
  //   小说管理
  {
    path: '/novelManage',
    name: 'NovelManage',
    component: NovelManage
  },
  //   个人信息管理
  {
    path: '/personalMessage',
    name: 'PersonalMessage',
    component: PersonalMessage
  },
  //   新建小说
  {
    path: '/newNovelCreate',
    name: 'NewNovelCreate',
    component: NewNovelCreate
  },
  //   隐私政策
  {
    path: '/yinSi',
    name: 'YinSi',
    component: YinSi
  },
  //   使用条款
  {
    path: '/shiYong',
    name: 'ShiYong',
    component: ShiYong
  },
  //   Cookie
  {
    path: '/cookie',
    name: 'Cookie',
    component: Cookie
  },
  //   打赏
  {
    path: '/encourage',
    name: 'Encourage',
    component: Encourage
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// 全局前置守卫：验证用户是否有权限访问
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('writer-auth');
    
    // 检查是否有 token
    if (!token) {
      // 没有 token，重定向到首页
      next('/');
      return;
    }
    
    // 简单验证 token 格式（实际项目中可以添加更复杂的验证）
    // 这里只是检查 token 是否存在，实际验证应该在每次 API 调用时由后端完成
    // 如果需要更严格的验证，可以在这里添加 JWT 解析和过期检查
    
    // 设置 Axios 默认 Authorization 头
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    next();
  } else {
    next();
  }
});

export default router
